<template>
  <div>
    <button style="font-weight: bold;" @click="openModal()" class="btn-outline btn-tertiary">
      <i class="fa-light fa-database"></i> Allocate VIBAN
    </button>
    <!-- modal allocate viban -->
    <div class="modal-container" v-if="isModalOpen">
      <div class="modal-content">
        <h1>Allocate VIBAN<i @click="closeModal()" class="fa-regular fa-xmark"></i></h1>
        <span>Enter a client number to allocate a VIBAN</span>
  
        <span v-if="allocateResult.length == 0">Client Number*</span>
        <input v-if="allocateResult.length == 0" type="text" class="filter-item-content" placeholder="CLI-12345678" @input="event => (clientNumber = event.target.value)"  @keyup.enter="confirmAllocation()"/>
  
  
        <div v-else>
          <div class="success" v-if="allocateResult[0].status == 200">
            <span>VIBAN allocated successfully</span>
            <div>
              <span>Client Number:</span>
              <span>{{ allocateResult[0].Reference1 }}</span>
              <span>VIBAN:</span>
              <span>{{ allocateResult[0].VIBAN }}</span>
            </div>
          </div>
          <div class="error" v-else>
            <span>Client already has VIBAN</span>
            <div>
              <span>Client Number:</span>
              <span>{{ allocateResult[0].Reference1 }}</span>
              <span>VIBAN:</span>
              <span>{{ allocateResult[0].VIBAN }}</span>
            </div>
          </div>
        </div>
        
        <div class="modal-content-buttons" >
          <button v-if="allocateResult.length == 0" class="btn-outline-light btn" @click="closeModal()">Cancel</button>
          <button :class="{inactive: clientNumber == null || clientNumber == ''}" v-if="allocateResult.length == 0" class="btn-outline btn-dark" @click="confirmAllocation()">Allocate</button>
          <button v-else class="btn-outline btn-dark" @click="closeModal()">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AllocateVIBANModal',
  emits: ['update:refresh'],
  data(){
    return{
      allocateResult: [],
      isModalOpen: false,
      clientNumber: null
    }
  },
  methods: {
    openModal () {
      this.isModalOpen = true
    },
    closeModal (){
      this.isModalOpen = false
      this.allocateResult = []
      this.clientNumber = null
    },
    confirmAllocation () {
      if(this.clientNumber == null) return
      this.$engine.services.payments.createGroup(this.clientNumber)
      .then(resp => {
        let resObj = {
          status: 200,
          VIBAN: resp.data.VIBAN,
          Reference1: resp.data.Reference1
        }
        this.$emit('update:refresh')
        this.allocateResult.push(resObj)
      })
      .catch(err => {
        let searchObj = {
          search: this.clientNumber
        }
        this.$engine.services.payments.getGroups(searchObj)
        .then(resp => {
          let resObj = {
            status: 400,
            VIBAN: resp.data.references[0].VIBAN,
            Reference1: resp.data.references[0].Reference1
          }
          this.allocateResult.push(resObj)
        })
        .catch(err => {
          this.$engine.services.payments.getGroups(searchObj)
        })
      })
    }
  }
}
</script>
<style scoped>

.inactive{
  color: #0a0a0a;
  opacity: 0.5;
  pointer-events: none;
  outline-style: none;
}

.error{
  border: 1px solid #febfbf;
  border-radius: calc(-2px + 1rem);
  padding: calc(.25rem * 3);
  height: 12rem;
  background-color: #ffefef;
}

.success{
  background-color: rgb(240, 253, 244);
  border: 1px solid #b9f8cf;
  border-radius: calc(-2px + 1rem);
  padding: calc(.25rem * 3);
  height: 12rem;
}

.success>div, .error>div{
  border-radius: 0.25rem;
  border: 1px solid #eff6ff; 
  background-color: #fff;
  padding: calc(.25rem * 3);
  height: 86%;
  display: grid;
}

.modal-container{
  width: 100vw; 
  height: 100vh; 
  position: fixed; 
  background-color: rgba(0, 0, 0, 0.5); 
  z-index: 5000; 
  overflow: hidden; 
  top: 0; 
  left: 0; 
  display: flex; 
  justify-content: center; 
  align-items: center;
}

.modal-content .filter-item {
  margin: 1rem 0rem;
}

.modal-content>h1{
  padding: 0;
  font-weight: bold;
  font-size: 1.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000;
}

.modal-content>h1>i{
  cursor: pointer;
}

.modal-content>input{
  margin-bottom: 1.5rem;
}

.modal-content>span:first-of-type{
  color: #717182;
  margin-bottom: 1rem;
}

.modal-content>span:last-of-type{
  color: #000;
  font-weight: bold;
}

.modal-content-buttons{
  display: flex;
  justify-content: end;
  gap: 1rem;
  align-items: center;
  margin-top: 1rem;
}

</style>